var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('scroll',[_c('div',[_c('BaseNavbar',{staticClass:"mb-12"}),_c('v-main',[_c('v-container',{staticStyle:{"max-width":"96%"},attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }